import styled from 'styled-components';

export const StyledPriceFakePrice = styled.div`
  height: 17px;
`;

export const StyledListingItemPriceLabel = styled.div<{
  hasDiscount?: boolean;
}>`
  width: ${({ hasDiscount }) => (hasDiscount ? '' : '100%')};
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: row;
  }
`;
export const ItemPriceDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  line-height: 12px;
`;

export const StartPriceLabel = styled.span`
  font-size: 10px;
  margin: 2px 0 2px 0;

  margin-left: 8px;
  font-weight: 400;
  word-wrap: break-word;
  display: block;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const RoomPeopleCount = styled.span`
  font-size: 10px;
  color: ${({ theme }) => theme.palette.grey800};
  font-weight: 700;
  margin-bottom: 8px;
`;

export const PriceInEUR = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 600;
  margin-top: -4px;
`;

export const MileSubtitle = styled.span`
  font-size: 10px;
  font-weight: 400;
  margin-right: 4px;
  color: ${({ theme }) => theme.palette.grey600};
`;

export const DiscountWrapper = styled.div`
  margin-right: 0;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const Flexbox = styled.div<{ direction: 'row' | 'column' }>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
`;
